import React from 'react';
import {Text} from 'react-native';

import {logForCrashlytics} from 'src/Utils/fireUtils';

export const formatNumberDisplayAmount = (num) => {
  logForCrashlytics('formatNumberDisplayAmount fired in formatHelper.js');

  num = Math.round(num);

  if (!num) {
    return 0;
  } else if (num > 1000 * 1000 * 1000 * 100) {
    return <Text> &#8734; </Text>;
  } else if (num > 1000 * 1000 * 1000) {
    return Math?.round(num / (1000 * 1000 * 1000), 1) + 'T';
  } else if (num > 1000 * 1000) {
    return Math?.round(num / (1000 * 1000), 1) + 'M';
  } else if (num > 9 * 1000) {
    return Math?.round(num / 100) / 10 + 'K';
  } else {
    return num.toLocaleString();
  }
};
